<div class="grid p-fluid">
    <div class="col-12 flex justify-content-end mb-2">
        <p-datepicker [(ngModel)]="selectedDate" (ngModelChange)="onDateChange()" dateFormat="dd/mm/yy" [showIcon]="true"
            appendTo="body" styleClass="w-full" inputStyleClass="text-sm p-2" [style]="{'min-width':'180px'}"></p-datepicker>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-blue-500 h-full cursor-pointer hover:surface-50 transition-colors"
             (click)="onKpiIngresosClick()"
             pTooltip="Ver evolución y últimos pedidos" tooltipPosition="top">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-semibold mb-3">Ingresos</span>
                    <div class="text-900 font-bold text-2xl">
                        {{ (stats?.salesToday || 0) | currency:'PEN':'symbol' }}
                    </div>
                </div>
                <div class="kpi-icon bg-blue-50">
                    <i class="pi pi-dollar text-blue-500 text-xl"></i>
                </div>
            </div>
            <span class="text-green-500 font-medium">Ventas Completas</span>
        </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-orange-500 h-full cursor-pointer hover:surface-50 transition-colors"
             (click)="togglePendingInMain()"
             pTooltip="Ver lista de pendientes" tooltipPosition="top">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-semibold mb-3">Pendientes</span>
                    <div class="text-900 font-bold text-2xl">{{ stats?.pendingOrdersCount || 0 }}</div>
                </div>
                <div class="kpi-icon bg-orange-50">
                    <i class="pi pi-clock text-orange-500 text-xl"></i>
                </div>
            </div>
            <span class="text-orange-500 font-medium">Click para detallar</span>
        </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-red-500 h-full cursor-pointer hover:surface-50 transition-colors"
             (click)="visibleStock = true"
             pTooltip="Ver productos críticos" tooltipPosition="top">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-semibold mb-3">Stock Crítico</span>
                    <div class="text-900 font-bold text-2xl">{{ stats?.lowStockCount || 0 }}</div>
                </div>
                <div class="kpi-icon bg-red-50">
                    <i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
                </div>
            </div>
            <span class="text-red-500 font-medium">&lt; 5 unidades</span>
        </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-cyan-500 h-full">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-semibold mb-3">Clientes</span>
                    <div class="text-900 font-bold text-2xl">{{ stats?.totalUsers || 0 }}</div>
                </div>
                <div class="kpi-icon bg-cyan-50">
                    <i class="pi pi-users text-cyan-500 text-xl"></i>
                </div>
            </div>
            <span class="text-cyan-500 font-medium">Registrados</span>
        </div>
    </div>

    <div class="col-12" *ngIf="showPendingInMain">
        <div class="surface-card shadow-1 p-4 border-round">
            <div class="flex justify-content-between align-items-center mb-3">
                <h5 class="text-xl font-bold m-0 text-900">Pedidos Pendientes de Atención</h5>
                <button pButton label="Volver al dashboard" icon="pi pi-arrow-left" class="p-button-text" (click)="togglePendingInMain()"></button>
            </div>
            <p-table #pendingOrdersTable [value]="pendingOrdersListSorted" dataKey="id"
                     [customSort]="true"
                     [sortField]="sortFieldPending" [sortOrder]="sortOrderPending" (onSort)="onPendingSort($event)"
                     styleClass="p-datatable-sm" [paginator]="true" [rows]="10" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 40px"></th>
                        <th pSortableColumn="id">ID <p-sortIcon field="id"></p-sortIcon></th>
                        <th class="text-center" pSortableColumn="isManualSale">Canal <p-sortIcon field="isManualSale"></p-sortIcon></th>
                        <th pSortableColumn="scheduledDate">Fecha Entrega <p-sortIcon field="scheduledDate"></p-sortIcon></th>
                        <th pSortableColumn="clientName">Cliente <p-sortIcon field="clientName"></p-sortIcon></th>
                        <th pSortableColumn="_tipoEnvio">Tipo de Envío <p-sortIcon field="_tipoEnvio"></p-sortIcon></th>
                        <th pSortableColumn="status">Estado <p-sortIcon field="status"></p-sortIcon></th>
                        <th class="text-right" pSortableColumn="totalAmount">Total <p-sortIcon field="totalAmount"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order let-expanded="expanded">
                    <tr class="cursor-pointer hover:surface-50">
                        <td>
                            <button type="button" pButton class="p-button-text p-button-rounded p-button-plain"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                    (click)="pendingOrdersTable.toggleRow(order, $event); $event.stopPropagation()"></button>
                        </td>
                        <td class="font-bold">#{{order.id}}</td>
                        <td class="text-center">
                            <i class="pi text-lg" [ngClass]="order.isManualSale ? 'pi-shopping-bag text-purple-500' : 'pi-globe text-blue-500'"
                               [pTooltip]="order.isManualSale ? 'Venta Manual' : 'Venta Web'" tooltipPosition="top"></i>
                        </td>
                        <td>{{ (order.scheduledDate || order.createdAt) | peruDate:'dd/MM/yyyy' }} <span *ngIf="order.scheduledTime" class="text-xs">{{ order.scheduledTime }}</span></td>
                        <td>{{order.clientName}}</td>
                        <td>{{ order.tipoEnvio?.nombreTipoEnvio || order.deliveryMethod || '—' }}</td>
                        <td><p-tag [value]="order.status" [severity]="getSeverity(order.status)"></p-tag></td>
                        <td class="text-right font-bold">{{ order.totalAmount | currency:'PEN':'symbol' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-order>
                    <tr>
                        <td colspan="8" class="bg-gray-50 p-3">
                            <div class="text-xs font-bold text-500 uppercase mb-2">Productos del pedido</div>
                            <div class="overflow-y-auto overflow-x-auto border-1 border-200 border-round" style="max-height: 280px;" *ngIf="order.items?.length; else noItemsPending">
                                <table class="w-full text-sm" style="min-width: 560px;">
                                    <thead>
                                        <tr class="text-left text-500 border-bottom-1 border-200">
                                            <th class="pb-2 pr-2">Nombre</th>
                                            <th class="pb-2 pr-2">Modelo</th>
                                            <th class="pb-2 pr-2">Color</th>
                                            <th class="pb-2 pr-2">Talla</th>
                                            <th class="pb-2 pr-2 text-center">Cantidad</th>
                                            <th class="pb-2 pr-2 text-right">Precio</th>
                                            <th class="pb-2">Observación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of order.items; let i = index" class="border-bottom-1 border-100">
                                            <td class="py-1 pr-2 font-medium">{{ item.product?.name || item.productName || item.product?.productName || 'Producto' }}</td>
                                            <td class="py-1 pr-2 text-600">{{ item.product?.modeloName || item.product?.modelo?.name || '—' }}</td>
                                            <td class="py-1 pr-2">{{ item.color || '—' }}</td>
                                            <td class="py-1 pr-2">{{ item.size || '—' }}</td>
                                            <td class="py-1 pr-2 text-center">{{ item.quantity ?? '—' }}</td>
                                            <td class="py-1 pr-2 text-right">{{ (item.unitPrice || item.product?.price || 0) | currency:'PEN':'symbol' }}</td>
                                            <td class="py-1 text-500">{{ i === 0 && order.notes ? order.notes : '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ng-template #noItemsPending><span class="text-500 text-sm">Sin ítems</span></ng-template>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="8" class="text-center p-4 text-green-600 font-bold"><i class="pi pi-check-circle mr-2"></i>No hay pedidos pendientes.</td></tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="col-12 lg:col-7" *ngIf="!showPendingInMain">
        <div class="surface-card shadow-1 p-4 border-round h-full">
            <div class="flex flex-column sm:flex-row justify-content-between align-items-start sm:align-items-center mb-4 gap-3">
                <h5 class="text-xl font-bold m-0 text-900">Evolución de Ventas</h5>
                

                <div class="flex flex-wrap gap-2 align-items-center">
                    <p-selectButton
                        [options]="rangeOptions"
                        [(ngModel)]="selectedRange"
                        (onChange)="onRangeChange()"
                        optionLabel="label"
                        optionValue="value"
                        styleClass="text-xs">
                    </p-selectButton>

                    <button pButton icon="pi pi-file-excel" class="p-button-success p-button-outlined p-button-sm"
                            pTooltip="Descargar Excel" tooltipPosition="top" (click)="exportExcel()"></button>
                    <button pButton icon="pi pi-file-pdf" class="p-button-danger p-button-outlined p-button-sm"
                            pTooltip="Descargar PDF" tooltipPosition="top" (click)="exportPdf()"></button>
                </div>
            </div>

            <div class="chart-container">
                <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="100%"></p-chart>
            </div>
        </div>
    </div>

    <div class="col-12 lg:col-5" *ngIf="!showPendingInMain">
        <div class="surface-card shadow-1 p-4 border-round h-full flex flex-column">
            <div class="flex justify-content-between align-items-center mb-2">
                <h5 class="text-xl font-bold m-0 text-900">Últimos Pedidos</h5>
                <button pButton icon="pi pi-arrow-right" class="p-button-text p-button-secondary font-bold"
                        label="Ver Todos" routerLink="/admin/orders/active"></button>
            </div>

            <p-table #recentOrdersTable [value]="stats?.recentOrders" styleClass="p-datatable-sm" responsiveLayout="scroll" [rowHover]="true"
                     dataKey="id" [paginator]="true" [rows]="10">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 36px"></th>
                        <th style="width: 10%">ID</th>
                        <th class="text-center" style="width: 10%">Canal</th>
                        <th style="width: 18%">Tipo Envío</th>
                        <th style="width: 28%">Cliente</th>
                        <th style="width: 14%">Categoría</th>
                        <th class="text-right" style="width: 14%">Total</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order let-expanded="expanded">
                    <tr class="text-sm cursor-pointer hover:surface-50">
                        <td>
                            <button type="button" pButton class="p-button-text p-button-rounded p-button-plain"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                    (click)="recentOrdersTable.toggleRow(order, $event); $event.stopPropagation()"></button>
                        </td>
                        <td class="font-bold text-900">#{{order.id}}</td>
                        <td class="text-center">
                            <i class="pi text-lg"
                               [ngClass]="order.isManualSale ? 'pi-shopping-bag text-purple-500' : 'pi-globe text-blue-500'"
                               [pTooltip]="order.isManualSale ? 'Venta Manual' : 'Venta Web'"
                               tooltipPosition="top">
                            </i>
                        </td>
                        <td class="text-xs">
                            <p-tag *ngIf="order.tipoEnvio?.nombreTipoEnvio" [value]="order.tipoEnvio.nombreTipoEnvio" severity="info" [rounded]="true" styleClass="text-xs"></p-tag>
                            <span *ngIf="!order.tipoEnvio?.nombreTipoEnvio" class="text-500">—</span>
                        </td>
                        <td>
                            <div class="font-semibold text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 140px;">
                                {{order.clientName}}
                            </div>
                            <div class="flex flex-wrap gap-1 mt-1" *ngIf="order.estados?.length">
                                <span *ngFor="let e of order.estados" class="text-xs px-2 py-0 border-round font-medium"
                                      [ngClass]="e.nombreEstado === 'En Ruta' ? 'bg-blue-100 text-blue-700' : e.nombreEstado === 'Confirmado' ? 'bg-green-100 text-green-700' : 'bg-surface-200 text-700'">
                                    {{ e.nombreEstado }}
                                </span>
                            </div>
                            <span class="text-xs text-500 block mt-1" *ngIf="!order.estados?.length">{{order.status}}</span>
                        </td>
                        <td class="text-xs text-600">{{ getOrderCategoryLabel(order) }}</td>
                        <td class="text-right font-bold text-900">
                            {{ order.totalAmount | currency:'PEN':'symbol':'1.0-0'}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-order>
                    <tr>
                        <td colspan="7" class="bg-gray-50 p-3">
                            <div class="text-xs font-bold text-500 uppercase mb-2">Productos del pedido</div>
                            <div class="overflow-y-auto overflow-x-auto border-1 border-200 border-round" style="max-height: 280px;" *ngIf="order.items?.length; else noItems">
                                <table class="w-full text-sm" style="min-width: 560px;">
                                    <thead>
                                        <tr class="text-left text-500 border-bottom-1 border-200">
                                            <th class="pb-2 pr-2">Nombre</th>
                                            <th class="pb-2 pr-2">Modelo</th>
                                            <th class="pb-2 pr-2">Color</th>
                                            <th class="pb-2 pr-2">Talla</th>
                                            <th class="pb-2 pr-2 text-center">Cantidad</th>
                                            <th class="pb-2 pr-2 text-right">Precio</th>
                                            <th class="pb-2">Observación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of order.items; let i = index" class="border-bottom-1 border-100">
                                            <td class="py-1 pr-2 font-medium">{{ item.product?.name || item.productName || item.product?.productName || 'Producto' }}</td>
                                            <td class="py-1 pr-2 text-600">{{ item.product?.modeloName || item.product?.modelo?.name || '—' }}</td>
                                            <td class="py-1 pr-2">{{ item.color || '—' }}</td>
                                            <td class="py-1 pr-2">{{ item.size || '—' }}</td>
                                            <td class="py-1 pr-2 text-center">{{ item.quantity ?? '—' }}</td>
                                            <td class="py-1 pr-2 text-right">{{ (item.unitPrice || item.product?.price || 0) | currency:'PEN':'symbol' }}</td>
                                            <td class="py-1 text-500">{{ i === 0 && order.notes ? order.notes : '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ng-template #noItems><span class="text-500 text-sm">Sin ítems</span></ng-template>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="7" class="text-center p-4 text-500 text-sm">No hay movimientos recientes.</td></tr>
                </ng-template>
            </p-table>
        </div>
    </div>

</div>


<p-dialog header="Alerta de Inventario (Stock Bajo)"
          [(visible)]="visibleStock"
          [modal]="true"
          [style]="{width: '50vw'}"
          [breakpoints]="{'960px': '95vw'}"
          [draggable]="false" 
          [resizable]="false">
    
    <p-table [value]="stats?.lowStockList" 
             styleClass="p-datatable-sm" 
             [paginator]="true" 
             [rows]="5"
             responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th>SKU</th>
                <th>Producto</th>
                <th>Variante</th>
                <th class="text-center">Cantidad</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td class="text-500 text-sm">{{item.sku}}</td>
                <td class="font-bold">{{item.productName}}</td>
                <td>
                    <p-tag [value]="item.size" severity="info" class="mr-2"></p-tag>
                    <span *ngIf="item.colorName" class="text-sm text-600">{{item.colorName}}</span>
                </td>
                <td class="text-center">
                    <p-tag [value]="item.quantity" [severity]="getStockSeverity(item.quantity)" [rounded]="true"></p-tag>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr><td colspan="4" class="text-center p-4 text-green-600 font-bold"><i class="pi pi-check-circle mr-2"></i>Todo el inventario está saludable.</td></tr>
        </ng-template>
    </p-table>
</p-dialog>